<script setup lang="ts">
import TrashIcon from '@/assets/icons/shared/trash.svg';
import UiButton from '@/modules/ui/components/ui/UiButton.vue';
import UiSpinner from '@/modules/ui/components/ui/UiSpinner.vue';
import { computed } from 'vue';

const { variant = 1 } = defineProps<{
  variant?: 1 | 2;
  loading?: boolean;
}>();

const CONFIG = {
  1: {
    button: {
      color: 'yellow',
      shape: 'auto',
      mode: 'fill',
    },
    spinner: {
      prefix: true,
      color: 'white',
    },
    icon: {
      prefix: true,
    },
    text: {
      show: true,
    },
  },
  2: {
    button: {
      color: 'black',
      shape: 'square',
      mode: 'outline',
    },
    spinner: {
      prefix: false,
      color: 'yellow',
    },
    icon: {
      prefix: false,
    },
    text: {
      show: false,
    },
  },
} as const;

const config = computed(() => CONFIG[variant]);
</script>

<template>
  <UiButton
    class="delete-button"
    :color="config.button.color"
    :shape="config.button.shape"
    :mode="config.button.mode"
    :disabled="loading"
  >
    <UiSpinner
      v-if="loading"
      v-prefix="config.spinner.prefix"
      :color="config.spinner.color"
    />
    <TrashIcon
      v-else
      v-prefix="config.icon.prefix"
    />
    <span v-if="config.text.show">{{ $t('ui.common.button.delete') }}</span>
  </UiButton>
</template>
